module.exports = __webpack_public_path__ + "static/Suhas_Motwani-7b11feb63b6b4f92e32a9cf6b100419d.jpeg";